import React, { useEffect, useState } from "react";
import Select from "react-select";
import Validations from "../../Utility/Validations";
import * as userActions from "../../../actions/index";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ImportCsvModal from "./ImportCsvModal";
import ApprovedCsvModal from "./ImportCsvModal"
import { Modal } from "react-bootstrap";
import { filterBreakpointKeys } from "@mui/system/Unstable_Grid/traverseBreakpoints";
import { TailSpin } from 'react-loader-spinner'


const customStyles = {
    // option: (provided, state) => ({
    //     ...provided,
    //     "&:hover": {
    //         backgroundColor: state.isFocused ? "#e7f5fe" : "",
    //     },
    //     backgroundColor: state.isSelected ? "#4a8fb8" : "",
    // }),

     option: (provided, state) => ({
  ...provided,
  "&:hover": {
    backgroundColor:
      !state.isSelected && state.isFocused ? "#e7f5fe" : "",
  },
  backgroundColor: state.isSelected ? "#4a8fb8" : "",
}),
};
const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
const school_code = user_info?.school_code === null || user_info === null ? "" : user_info?.school_code;
const StudentImport = (props) => {
    const [showLoader, setShowLoader] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [showModal2, setShowModal2] = useState(false)
    const [errorArray, setErrorArray] = useState([])
    const [dataArray, setDataArray] = useState([])
    const [filterCsv, setFilterCsv] = useState([])
    const [confirmData, setCofirmData] = useState([])
    const [understand, setUnderstand] = useState(false)
    const [filterCsvData, setFilterCsvData] = useState([])
    const [csv_student_details, setCsv_student_details] = useState([])
    const [countryPhoneCode, setCountryPhoneCode] = useState()
    const [schoolCountaryName, setSchoolCountaryNmae] = useState('')
    const [country_phone_list, setCountry_phone_list] = useState([])
    const [dormitoryWarning, setDormitoryWarning] = useState(false)
    const [dormitoryWarningData, setDormitoryWarningData] = useState(null)
    const [pendingFile, setPendingFile] = useState(null)

    const [import_student_form, setImport_student_form] = useState({

        class_id: {
            type: "select",
            label: "Select class *",
            value: "",
            valid: true,
            error_msg: "",
            onBlur_out: false,
            placeholder: "",
            validations: { required: true },
            options: [],
        },

        class_name: {
            type: "text",
            label: "Select class *",
            value: "",
            valid: true,
            error_msg: "",
            onBlur_out: false,
            placeholder: "",
            validations: { required: true },
            options: [],
        },

        dormitory_name: {
            type: "text",
            label: "Select Domitory *",
            value: "",
            valid: true,
            error_msg: "",
            onBlur_out: false,
            placeholder: "",
            validations: { required: true },
        },

        dormitory_id: {
            type: "select",
            label: "Select Dormitory *",
            value: "",
            valid: true,
            error_msg: "",
            onBlur_out: false,
            placeholder: "",
            validations: { required: true },
            options: [],
        },

        students_csv: {
            type: "file",
            label: "File",
            value: '',
            valid: true,
            error_msg: "",
            validations: { required: false },
            thumbnail_image: "/assets/media/school-logo.png",
        },

        school_name: {
            type: "hidden",
            label: "",
            value: "",
            valid: true,
            error_msg: "",
            onBlur_out: false,
            placeholder: "",
            validations: { required: true },

        },

        school_detail_id: {
            type: "hidden",
            label: "",
            value: "",
            valid: true,
            error_msg: "",
            onBlur_out: false,
            placeholder: "",
            validations: { required: true },


        },
    }
    )

    const navigate = useNavigate();

    useEffect(() => {
        GetAllDormitoryImport();
        GetAllClassesList();
        GetAllCountriesForImportStudents();
    }, [])

    const GetAllDormitoryImport = async (form_data) => {
        props.onGetAllDormitoryImport().then((response) => {
            let country_level = [];
            country_level.push({
                label: "Select Dormitory",
                value: "",
            });
            const update_import_student_form = { ...import_student_form };
            if (response.success === true) {
                const arrayData = response.data.rows;
                for (let key in arrayData) {
                    if (arrayData[key].dormitory_status === true) {
                        country_level.push({
                            label: arrayData[key].dormitory_name,
                            value: arrayData[key].dormitory_id,
                            is_dummy: arrayData[key].is_dummy,
                            // dormitory_id_name: arrayData[key].dormitory_id_name,  
                        });
                    }
                }
            }
            update_import_student_form['dormitory_id'].options = country_level;
            setImport_student_form(update_import_student_form);
        });
    }


    const GetAllClassesList = async (form_data) => {
        props.onGetAllClassesList().then((response) => {
            let country_level = [];
            country_level.push({
                label: "Select Class",
                value: "",
            });
            const update_import_student_form = { ...import_student_form };
            if (response.success === true) {
                const arrayData = response.data.rows;
                for (let key in arrayData) {
                    if (arrayData[key].is_class_activate === true) {
                        country_level.push({
                            label: arrayData[key].class_name,
                            value: arrayData[key].class_id,
                            class_name: arrayData[key].class_name,
                            is_dummy: arrayData[key].is_dummy,
                        });
                    }
                }
            }
            update_import_student_form['class_id'].options = country_level;
            setImport_student_form(update_import_student_form);
        });
    }

    const GetImportStudentDetails = async (event, identifier) => {
        var file = event.target.files[0];
        setPendingFile(file);
        setShowLoader(true);
        let payload = {
            students_csv: file,
            dormitory_id: import_student_form.dormitory_id.value,
            dormitory_confirm: false,
        }
        props.onGetImportStudentDetails(payload).then((response) => {
            setShowLoader(false);
            console.log("response============", response);
            if (response.dormitory_warning === true) {
                setDormitoryWarning(true);
                setDormitoryWarningData(response);
            } else if (response.success === true) {
                let arrayData = []
                const impStuData = response.data;
                for (let key in impStuData) {
                    arrayData.push(impStuData[key])
                }
                console.log(arrayData, response, "::ASdasd")
                setCsv_student_details(arrayData)
                setShowModal(true)
            } else {
                toast.error(response.message || response.error, {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        });
    }

    const handleDormitoryWarningContinue = () => {
        setShowLoader(true);
        let payload = {
            students_csv: pendingFile,
            dormitory_id: import_student_form.dormitory_id.value,
            dormitory_confirm: true,
        }
        props.onGetImportStudentDetails(payload).then((response) => {
            setShowLoader(false);
            console.log("response============", response);
            setDormitoryWarning(false);
            setDormitoryWarningData(null);
            if (response.success === true) {
                let arrayData = []
                const impStuData = response.data;
                for (let key in impStuData) {
                    arrayData.push(impStuData[key])
                }
                setCsv_student_details(arrayData)
                setShowModal(true)
            } else {
                toast.error(response.message || response.error, {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        });
    }

    const handleDormitoryWarningBack = () => {
        setDormitoryWarning(false);
        setDormitoryWarningData(null);
        setPendingFile(null);
        const file = document.querySelector('.CSV_file');
        if (file) file.value = '';
    }
    const GetAllCountriesForImportStudents = async () => {
        const local_country_id = JSON.parse(localStorage.getItem("bss_authuser")).user_school.country_id;
        props.onGetAllCountriesForImportStudents().then((response) => {
            if (response.success === true) {
                const countryData = response.data.rows;
                let country_list = []
                for (let key in countryData) {
                    country_list.push({ name: countryData[key].name, phone_code: countryData[key].phone_code })
                }
                const filterCountryData = countryData.filter(item => item.country_id === local_country_id)
                console.log("GetAllCountriesForImportStudents", filterCountryData);
                setCountryPhoneCode(filterCountryData[0].phone_code)
                setSchoolCountaryNmae(filterCountryData[0].name)
                setCountry_phone_list(country_list)
            }
        });
    }


    const handleChange = (data, identifier, type) => {
        const update_import_student_form = { ...import_student_form };
        if (identifier === 'dormitory_id') {
            update_import_student_form['dormitory_name'].value = data.label;
        }
        if (identifier === 'class_id') {
            update_import_student_form['class_name'].value = data.label;
        }
        const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
        update_import_student_form['school_name'].value = user_info.user_school.school_name;
        update_import_student_form['school_detail_id'].value = user_info.school_detail_id;
        update_import_student_form[identifier].value = data.value;
        setImport_student_form(update_import_student_form);
    }




    const SubmitHandlerData = async (data) => {
        let is_form_valid = true;
        const update_import_student_form = import_student_form;
        for (let key in update_import_student_form) {
            let form_element = update_import_student_form[key];
            let validate_element = Validations(form_element);
            is_form_valid = validate_element.valid === false ? false : is_form_valid;
            form_element.onBlur_out = true;
            form_element.valid = validate_element.valid;
            form_element.error_msg = validate_element.error_msg;
            update_import_student_form[key] = form_element;
        }
        setImport_student_form(update_import_student_form);
        if (is_form_valid) {
            const form_data = {};
            let country_code_error = [];

            for (let key in import_student_form) {
                if (key !== "students_csv") {
                    form_data[key] = import_student_form[key].value;
                }
            }
            const csv_data_phone_code = filterCsvData.map((item) => {
                let parent1_phone_code = countryPhoneCode;
                let father_countary_name = schoolCountaryName;
                console.log("countryPhoneCode------", countryPhoneCode);
                if (item.parent1_country.toLowerCase() === "america" || item.parent1_country.toLowerCase() === "usa" || item.parent1_country.toLowerCase() === "united states" || item.parent1_country.toLowerCase() === "canada") {
                    parent1_phone_code = 1
                } else if (item.parent1_country.toLowerCase() === "united kingdom" || item.parent1_country.toLowerCase() === "uk" || item.parent1_country.toLowerCase() === "england" || item.parent1_country.toLowerCase() === "britian") {
                    parent1_phone_code = 44
                } else if (item.parent1_country === "") {
                    parent1_phone_code = countryPhoneCode
                } else {
                    const result = country_phone_list.find((obj) => {
                        return obj.name.toLowerCase() === item.parent1_country.toLowerCase()
                    });
                    console.log("result.phone_code", result);
                    if (result == undefined) {
                        // country_code_error.push(item.parent1_country)
                        parent1_phone_code = countryPhoneCode
                    } else {
                        parent1_phone_code = result.phone_code

                    }
                }

                let parent2_phone_code = countryPhoneCode
                let mother_countary_name = schoolCountaryName;
                if (item.parent2_country.toLowerCase() === "america" || item.parent2_country.toLowerCase() === "usa" || item.parent2_country.toLowerCase() === "united states" || item.parent2_country.toLowerCase() === "canada") {
                    parent2_phone_code = 1
                } else if (item.parent2_country.toLowerCase() === "united kingdom" || item.parent2_country.toLowerCase() === "uk" || item.parent2_country.toLowerCase() === "england" || item.parent1_country.toLowerCase() === "britian") {
                    parent2_phone_code = 44
                } else if (item.parent2_country === "") {
                    parent2_phone_code = countryPhoneCode
                } else {
                    const result = country_phone_list.find((obj) => {
                        return obj.name.toLowerCase() === item.parent2_country.toLowerCase()
                    });
                    if (result == undefined) {
                        // country_code_error.push(item.parent2_country)
                        parent2_phone_code = countryPhoneCode
                    } else {
                        parent2_phone_code = result.phone_code
                    }
                }
                return (
                    {
                        ...item,
                        parent1_country: parent1_phone_code == countryPhoneCode ? schoolCountaryName : item.parent1_country,
                        parent2_country: parent2_phone_code == countryPhoneCode ? schoolCountaryName : item.parent2_country,
                        student_phone: countryPhoneCode + item.student_phone,
                        parent1_home_phone: parent1_phone_code + item.parent1_home_phone,
                        father_mobile_cell: parent1_phone_code + item.father_mobile_cell,
                        parent1_work_phone: parent1_phone_code + item.parent1_work_phone,
                        mother_mobile_cell: parent2_phone_code + item.mother_mobile_cell,
                        parent2_home_phone: parent2_phone_code + item.parent2_home_phone,
                        parent2_work_phone: parent2_phone_code + item.parent2_work_phone,
                    }
                )
            })
            console.log("csv_data_phone_code", csv_data_phone_code);
            form_data['csv_student_details'] = JSON.stringify(csv_data_phone_code)
            if (understand === true) {
                // if (country_code_error.length === 0) {
                setShowLoader(true)
                props.onImportStudentsCsv(form_data).then((response) => {
                    if (response.success === true) {
                        setShowModal2(false)
                        setShowLoader(false)
                        console.log("response.message", response.message);
                        toast.success(response.message, {
                            position: toast.POSITION.TOP_CENTER,
                        });
                    } else {
                        setShowLoader(false)
                        toast.error(response.message, {
                            position: toast.POSITION.TOP_CENTER,
                        });
                    }
                });
                // } else {
                //     toast.error(`(${country_code_error.country.join(' , ')}) These countries don't exist`, {
                //         position: toast.POSITION.TOP_CENTER,
                //     });
                // }
            } else {
                toast.error("To proceed with importing students, please tick the box.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } else {
            toast.error("Select Dormitory and Year first", {
                position: toast.POSITION.TOP_CENTER,
            });
        }
    };


    const showModalHandler = (value) => {
        setShowModal(value)
        const file = document.querySelector('.CSV_file');
        file.value = '';
    }

    const openSecondModal = (data) => {
        if (showModal) { setShowModal(false) };
        setShowModal2(true)
        const filterData = []
        data.forEach((item) => {
            filterData.push(item.valid)
        })
        setErrorArray(filterData)
        setFilterCsvData(data)
        const file = document.querySelector('.CSV_file');
        file.value = '';
    };
    const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
    const cancleApproveModal = () => {
        setShowModal2(false)
    }

    console.log(import_student_form?.class_id?.value && import_student_form?.dormitory_id?.value,":34567:fhgvbasdf" )
    return (
        <>
            {showLoader &&
                <div style={{ backdropFilter: "blur(10px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: "99999999", position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "#b8b8b82b" }}>
                    <div >
                        <TailSpin
                            visible={showLoader}
                            height="100"
                            width="100"
                            color="#3693d0"
                            ariaLabel="tail-spin-loading"
                            radius="1"
                            wrapperStyle={{}}
                            wrapperClass=""
                        />
                    </div>

                </div>
            }
            {dormitoryWarning && dormitoryWarningData && (
                <div style={{ position: "fixed", width: "100%", minHeight: "100%", zIndex: "9999", backgroundColor: "#0000097a", left: 0, top: 0 }}>
                    <div className="position-relative py-0 details-bg">
                        <div className="row">
                            <div className="col-6 m-auto">
                                <div className="card my-5 tabs-outer">
                                    <div className="card-header position-relative py-0 details-bg">
                                        <h2 className="card-title m-0">Dormitory Warning</h2>
                                    </div>
                                    <div className="card-body position-relative py-5">
                                        <div className="d-flex align-items-start mb-4">
                                            <span className="me-3"><i className="fas fa-exclamation-triangle fa-lg" style={{ color: "#fa8c00" }}></i></span>
                                            <p className="mb-0">{dormitoryWarningData.message}</p>
                                        </div>
                                        <div className="d-flex gap-4 mb-3">
                                            <span className="badge badge-light-primary fs-6 px-4 py-2">Male students: {dormitoryWarningData.male_count}</span>
                                            <span className="badge badge-light-danger fs-6 px-4 py-2">Female students: {dormitoryWarningData.female_count}</span>
                                        </div>
                                    </div>
                                    <div className="card-footer py-4 px-6">
                                        <div className="d-flex justify-content-end gap-3">
                                            <button className="btn btn-sm btn-secondary apply-btn min-150px" onClick={handleDormitoryWarningBack}>Back</button>
                                            <button className="btn btn-sm btn-primary apply-btn min-150px" onClick={handleDormitoryWarningContinue}>Continue</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showModal && <ImportCsvModal
                showModal={showModal}
                csv_student_details={csv_student_details}
                setCsv_student_details={setCsv_student_details}
                import_student_form={import_student_form}
                showModalHandler={(value) => showModalHandler(value)}
                openSecondModal={openSecondModal}
                onGetImportStudentDetails = {props.onGetImportStudentDetails}
                onGetReviewAgainImportStudents= {props.onGetReviewAgainImportStudents}
                onSearchLocation={props.onSearchLocation}
                dormitory_id={import_student_form.dormitory_id.value}
            />}

            {showModal2 === true &&
                <div style={{ position: "fixed", width: "100%", minHeight: "100%", zIndex: "999", backgroundColor: "#0000097a", left: 0, top: 0 }}>
                    <div className="position-relative py-0 details-bg">
                        <div className="row">
                            <div className="col-8 m-auto">
                                <div className="card my-5 tabs-outer">
                                    <div className="card-header position-relative py-0 details-bg">
                                        <h2 className="card-title  m-0">Import Student Alert</h2>
                                    </div>
                                    <div>
                                        <div className="card-body position-relative py-5">
                                            {errorArray.includes(false) ?
                                                <div className="">
                                                    <div className="d-flex">
                                                        <spn className="me-4"><i class="fas fa-exclamation-triangle fa-lg" style={{ color: "#fa0000a3" }}></i></spn>
                                                        <span><h4>1 of 4 possible errors have likely occurred:-</h4></span>
                                                    </div>

                                                    <p>
                                                        1)  Insufficient data has been supplied in this .csv file.  Please check .csv file for content or format errors and re-upload it. Names marked in RED indicate incomplete ESSENTIAL information. (Not all information is essential)
                                                    </p>
                                                    <p>
                                                        2)  The student has identifying data that has been duplicated.  This may be Cell No, email address or Name.
                                                    </p>
                                                    <p>
                                                        3)  You may have not followed EXACT word format instructions.  Eg Date format or spelling format, including correct use of Capital Letters.
                                                    </p>
                                                    <p>
                                                        4)  You may have simply not selected “Class” or “Dormitory” from the selection options to associate with these students.
                                                    </p>


                                                    {/* <p className="m-4">Insufficient data has been supplied in this .csv file for the system to assist in managing one or more students.  Please check .csv file and re-upload it. The entries marked in RED are the ones having incomplete information.</p> */}
                                                </div>
                                                :

                                                <div>
                                                    <p className="text-secondary">For this import minimal information has been supplied, for full functionality additional information would need to be added at some point.  This may be Parent Contact Details or other information that has been omitted from the CSV file data, at this stage.  </p>
                                                    <div className="my-5">
                                                        <label className="checkbox cursor-pointer ">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input me-1"
                                                                value={understand}
                                                                checked={understand}
                                                                onChange={(e) => setUnderstand(e.target.checked)}
                                                            />
                                                            <span className="mb-0">
                                                                I understand
                                                            </span>
                                                        </label>
                                                    </div>

                                                </div>
                                            }



                                        </div>
                                        <div className="card-footer py-5 px-10">
                                            <div className="d-flex justify-content-end">
                                                {
                                                    errorArray.includes(false) ? "" :
                                                        <button className="btn btn-sm btn-primary apply-btn min-150px me-5" onClick={() => SubmitHandlerData()}>Submit</button>
                                                }

                                                <button className="btn btn-sm btn-secondary apply-btn min-150px" onClick={cancleApproveModal}>Cancel </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }








            <div className="card tabs-outer">
                <div className="card-header position-relative py-0 details-bg">
                    <h2 className="card-title  m-0">Import Student</h2>
                </div>

                <div className="card-body add-new-schools p-6">
                    <div className="row">
                        <div className="col-lg-6 fv-row mb-5">
                            <label className="fw-bold mb-2">{import_student_form.class_id.label}</label>
                            <Select
                                styles={customStyles}
                                className="react-bootstrap-typeahead tag-outer"
                                options={import_student_form.class_id.options}
                                isOptionDisabled={(option) => option.is_dummy}
                                value={import_student_form.class_id.options.filter(function (option) {
                                    return option.value === import_student_form.class_id.value;
                                })}
                                onChange={(newValue) => handleChange(newValue, "class_id")}
                            />
                            {!import_student_form.class_id.valid && import_student_form.class_id.onBlur_out ? <div className="error field-error">{import_student_form.class_id.error_msg}</div> : ""}
                        </div>

                        <div className="col-lg-6 fv-row mb-5">
                            <label className="fw-bold mb-2">{import_student_form.dormitory_id.label}</label>
                            <Select
                                styles={customStyles}
                                className="react-bootstrap-typeahead tag-outer"
                                options={import_student_form.dormitory_id.options}
                                isOptionDisabled={(option) => option.is_dummy}
                                value={import_student_form.dormitory_id.options.filter(function (option) {
                                    return option.value === import_student_form.dormitory_id.value;
                                })}
                                onChange={(newValue) => handleChange(newValue, "dormitory_id")}
                            />
                            {!import_student_form.dormitory_id.valid && import_student_form.dormitory_id.onBlur_out ? <div className="error field-error">{import_student_form.dormitory_id.error_msg}</div> : ""}
                        </div>

                        <div>
                            <input
                                type={import_student_form.school_name.type}
                                value={user_info.user_school.school_name ? user_info.user_school.school_name : "1234"}
                                className="form-control"
                            />
                        </div>

                        <div>
                            <input
                                type={import_student_form.school_detail_id.type}
                                value={user_info.school_detail_id ? user_info.school_detail_id : "1234"}
                            />
                        </div>

                        <div className="col-lg-6 fv-row mb-5">

                            <label className="fw-bold mb-2 w-100 " style={{textTransform:"none"}}>.xlsx File only</label>
                            <label className="btn btn-sm btn-outline-primary rounded-50 ">

                                <input hidden=""
                                    type="file"
                                    accept=".xlsx"
                                    onChange={(event) => GetImportStudentDetails(event, "students_csv")}
                                    className="CSV_file"
                                    disabled={!(import_student_form?.class_id?.value && import_student_form?.dormitory_id?.value)}
                                />
                            </label>
                            {!import_student_form.students_csv.valid && import_student_form.students_csv.onBlur_out ? <div className="error field-error">{import_student_form.students_csv.error_msg}</div> : ""}
                        </div>
                    </div>
                    <div className="d-flex">
                        <h4>* </h4>
                        <span className="fw-bold ">&#160;Please note that by default, the parent's country would be the same as the country where the school is situated. You can change it manually from the student's profile.</span>
                    </div>
                </div>
            </div>
        </>
    );

}

function mapStateToProps(state) {
    return {

    };
}
const mapDispatchToProps = {
    onImportStudentsCsv: userActions.ImportStudentsCsv,
    onGetAllDormitoryImport: userActions.GetAllDormitoryImport,
    onGetAllClassesList: userActions.GetAllClassesList,
    onGetImportStudentDetails: userActions.GetImportStudentDetails,
    onGetReviewAgainImportStudents: userActions.GetReviewAgainImportStudents,
    onGetAllSelectedCountries: userActions.GetAllSelectedCountries,
    onGetAllCountriesForImportStudents: userActions.GetAllCountriesForImportStudents,
    onSearchLocation: userActions.SearchLocation,
};
export default connect(mapStateToProps, mapDispatchToProps)(StudentImport);

